import React from 'react';
import FormWrapper from './FormWrapper';
import { Input, Textarea, Box } from '@chakra-ui/react';
import {isFunction, upperFirst} from 'lodash';

// XSS prevention: strip dangerous HTML/JS characters
const escapeHtml = (str) => {
    if (!str) return str;
    return str.replace(/[<>'"&]/g, '');
};

const TextInput = (props) => {
    const {
        formik,
        i18n,
        index,
        name,
        label,
        title,
        serverValidator,
        inputProps,
        textArea = false,
        disabled,
        readOnly,
        CustomInput,
        CondationInput,
        placeholder,
        isUpperFirst = false,
    } = props;
    const value = formik.values[name];
    // 最大字符数，只有传入 props.maxLength 时才限制，否则不限制
    const maxLength = typeof props.maxLength === 'number' ? props.maxLength : undefined;
    const InputComponentArea = CondationInput
        ? CondationInput(formik.values)
        : CustomInput
        ? CustomInput
        : Textarea;
    const InputComponent = CondationInput
        ? CondationInput(formik.values)
        : CustomInput
        ? CustomInput
        : Input;
    const _disabled = isFunction(disabled) ? disabled(formik.values) : disabled;
    return (
        <FormWrapper {...props}>
            {textArea ? (
                <>
                    <InputComponentArea
                        h={32}
                        isDisabled={_disabled}
                        isReadOnly={readOnly}
                        onChange={(e) => {
                            const v = escapeHtml(e.target.value);
                            if (typeof maxLength === 'number') {
                                if (v.length <= maxLength) {
                                    formik.setFieldValue(name, v);
                                }
                            } else {
                                formik.setFieldValue(name, v);
                            }
                        }}
                        value={value}
                        autoCapitalize="none"
                        size="sm"
                        variant="outline"
                        placeholder={placeholder || i18n('enter')}
                        {...(typeof maxLength === 'number' ? { maxLength } : {})}
                    />
                    {typeof maxLength === 'number' && (
                        <Box textAlign="right" fontSize="xs" color="gray.500" mt={1}>
                            {value?.length || 0} / {maxLength}
                        </Box>
                    )}
                </>
            ) : (
                <InputComponent
                    isDisabled={_disabled}
                    isReadOnly={readOnly}
                    onChange={(e) =>
                        formik.setFieldValue(
                            name,
                            isUpperFirst
                                ? upperFirst(escapeHtml(e.target.value))
                                : escapeHtml(e.target.value),
                        )
                    }
                    value={value}
                    autoCapitalize="none"
                    size="sm"
                    variant="outline"
                    placeholder={placeholder || i18n('enter')}
                    // onBlur={() => {
                    //     formik.setFieldTouched(name, true);
                    // }}
                    {...inputProps}
                />
            )}
        </FormWrapper>
    );
};
// export default TextInput;
export default React.memo(TextInput, (prev, next) => {
    const name = prev.name;
    return (
        prev.formik.values[name] === next.formik.values[name] &&
        prev.formik.errors[name] === next.formik.errors[name] &&
        prev.formik.touched[name] === next.formik.touched[name] &&
        prev.disabled === next.disabled &&
        prev.readOnly === next.readOnly && 
        prev.i18n === next.i18n 
    );
});
